"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

interface FaqItem {
  question: string;
  answer: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="flex flex-col">
      {items.map((item, i) => {
        const isOpen = open === i;

        return (
          <div key={i} className="border-t border-black/10">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="w-full cursor-pointer text-left grid grid-cols-[auto_1fr_auto] md:grid-cols-[1fr_1fr_auto] gap-4 md:gap-0 items-start py-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20 rounded"
            >
              <span className="font-mono text-xs text-gray-500 uppercase pt-1">
                ({i + 1})
              </span>
              <div className="flex flex-col gap-3">
                <p className="text-base text-black tracking-tight">
                  {item.question}
                </p>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <p className="text-base text-gray-600 tracking-tight max-w-lg pb-2">
                        {item.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              <div className="text-black w-6 flex items-center justify-center" aria-hidden="true">
                {isOpen ? <Minus size={20} strokeWidth={1.5} /> : <Plus size={20} strokeWidth={1.5} />}
              </div>
            </button>
          </div>
        );
      })}
      <div className="border-t border-black/10" />
    </div>
  );
}
